import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import UserDataCollector from "./components/UserDataCollector";
import { SourceProvider } from "./contexts/DataContext";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <SourceProvider>
      <UserDataCollector />
      <App />
    </SourceProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
